import type {
  BillingInterval,
  OrderStatus,
  SubscriptionCancelType,
  SubscriptionCancellationRequestStatus,
  SubscriptionInvoiceBillingReason,
  SubscriptionInvoiceStatus,
  SubscriptionStatus
} from '../../types'

export const subscriptionStatusMeta: Record<SubscriptionStatus, { label: string; color: string }> = {
  PENDING: { label: '待開通', color: 'gold' },
  ACTIVE: { label: '生效中', color: 'green' },
  PAST_DUE: { label: '逾期', color: 'orange' },
  SUSPENDED: { label: '已暫停', color: 'volcano' },
  CANCEL_AT_PERIOD_END: { label: '週期末取消', color: 'blue' },
  CANCELLED: { label: '已取消', color: 'default' },
  TERMINATED: { label: '已終止', color: 'red' }
}

export const invoiceStatusMeta: Record<SubscriptionInvoiceStatus, { label: string; color: string }> = {
  PENDING: { label: '待支付', color: 'gold' },
  PAID: { label: '已支付', color: 'green' },
  FAILED: { label: '支付失敗', color: 'red' },
  VOID: { label: '已作廢', color: 'default' }
}

export const orderStatusMeta: Record<OrderStatus, { label: string; color: string }> = {
  CREATING: { label: '創建中', color: 'processing' },
  PENDING: { label: '待支付', color: 'gold' },
  PAID: { label: '已支付', color: 'green' },
  SETTLED: { label: '已結算', color: 'blue' },
  REFUNDED: { label: '已退款', color: 'orange' },
  DISPUTED: { label: '爭議中', color: 'red' },
  CHARGEBACK: { label: '拒付', color: 'red' },
  FAILED: { label: '失敗', color: 'red' },
  CLOSED: { label: '已關閉', color: 'default' },
  REVOKED: { label: '已撤銷', color: 'default' }
}

export const billingReasonText: Record<SubscriptionInvoiceBillingReason, string> = {
  SUBSCRIPTION_INITIAL: '首期扣款',
  SUBSCRIPTION_RECURRING: '續費扣款'
}

export const cancelTypeText: Record<SubscriptionCancelType, string> = {
  PERIOD_END: '週期末取消',
  IMMEDIATE: '立即取消'
}

export const cancellationStatusMeta: Record<SubscriptionCancellationRequestStatus, { label: string; color: string }> = {
  REQUESTED: { label: '已請求', color: 'processing' },
  SCHEDULED: { label: '已預約', color: 'blue' },
  CONFIRMED: { label: '已確認', color: 'green' },
  FAILED: { label: '失敗', color: 'red' },
  UNKNOWN: { label: '結果未知', color: 'orange' }
}

export const intervalText: Record<BillingInterval, string> = {
  DAY: '日',
  WEEK: '週',
  MONTH: '月',
  YEAR: '年'
}

export function formatBillingInterval(interval: BillingInterval, count: number): string {
  return count === 1 ? `每${intervalText[interval]}` : `每 ${count} ${intervalText[interval]}`
}

export function formatSubscriptionTerm(interval: BillingInterval, count: number, totalBillingCycles?: number | null): string {
  const billingText = formatBillingInterval(interval, count)
  return `${billingText} · ${totalBillingCycles ? `共 ${totalBillingCycles} 期` : '無限期'}`
}

export function formatCard(brand?: string | null, last4?: string | null): string {
  if (!brand && !last4) return '-'
  return [brand?.toUpperCase(), last4 ? `•••• ${last4}` : undefined].filter(Boolean).join(' ')
}

export function canCancelSubscription(status: SubscriptionStatus): boolean {
  return ['ACTIVE', 'PAST_DUE', 'SUSPENDED', 'CANCEL_AT_PERIOD_END'].includes(status)
}
